enum PERIOD_END_DATA_OPTIONS {
  NONE = 'NONE',
  PREVIOUS_MONTH_END = 'PREVIOUS_MONTH_END',
  RECENT_MONTH_END = 'RECENT_MONTH_END',
  PREVIOUS_QUARTER_END = 'PREVIOUS_QUARTER_END',
  RECENT_QUARTER_END = 'RECENT_QUARTER_END',
  AUTO = 'AUTO',
}

export default PERIOD_END_DATA_OPTIONS;
